document.addEventListener("DOMContentLoaded", () => {

  const list = document.querySelector(".blog-post-list");
  if (!list) return;

  let nextPage = document.querySelector(".pagination a[rel='next']");
  let loading = false;

  async function loadMore() {
    if (!nextPage || loading) return;

    loading = true;

    // Affiche la barre de chargement du thème Prestige
    document.dispatchEvent(new CustomEvent("theme:loading:start"));

    try {
      const response = await fetch(nextPage.href);
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newArticles = doc.querySelectorAll(".blog-post-list > *");

      newArticles.forEach(article => {
        list.appendChild(article);
      });

      nextPage = doc.querySelector(".pagination a[rel='next']");

    } finally {
      loading = false;

      // Cache la barre de chargement
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
    }
  }

  window.addEventListener("scroll", () => {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 500
    ) {
      loadMore();
    }
  });

});